import React from 'react'
import IndexStarpath from "../../components/index/IndexStarpath";

const StarpathHome = () => {
  return (
     <IndexStarpath/>
  )
}

export default StarpathHome